import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props =>
    `${props.theme.spacing.sp8} ${props.theme.spacing.sp8} ${props.theme.spacing.sp16} ${props.theme.spacing.sp8}`};
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const LineItemContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const LineItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const IconsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  min-width: 30px;

  div {
    height: 30px;
  }
`

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp8};
`

export const NotesContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const IconContainer = styled.div`
  width: ${props => props.theme.spacing.sp24};
  margin-bottom: ${props => props.theme.spacing.sp12};
`
